import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { props } from "skatejs";
import WidgetTracker from "../common/components/WidgetTracker/WidgetTracker";
import { getUserEmail } from "../common/utils/storage";
import { PortfolioCumulativeNbi } from "./components/PortfolioCumulativeNbi";

// tslint:disable-next-line:interface-name
interface Props {
  filters?: { [attribute: string]: string[] | string };
  userEmail?: string;
}

class CprPortfolioCumulativeNbi extends SgWidget<Props> {
  public static is = "cpr-portfolio-cumulative-nbi";

  public static props = {
    filters: props.object,
    userEmail: props.string,
  };

  public render(intraProps: Props) {
    const headers = { uiscreen: (this.constructor as any).is };
    const userEmail = this.props.userEmail || getUserEmail(localStorage);
    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <PortfolioCumulativeNbi
            filters={this.props.filters}
            userEmail={userEmail}
            headers={headers}
          />
          <WidgetTracker widgetName={CprPortfolioCumulativeNbi.is} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}

initializeWidgetConfiguration(CprPortfolioCumulativeNbi);
customElements.define(CprPortfolioCumulativeNbi.is, CprPortfolioCumulativeNbi);
